import React, { useEffect, useState } from "react";
import axios from "axios";
import AdsComponent from "../../AdsComponent/AdsComponent";

const BannerAdComponent = () => {
    const [shouldShowBanner, setShouldShowBanner] = useState(false);

    useEffect(() => {
        const fetchBannerSetting = async () => {
            try {
                const res = await axios.get(
                    "https://rollingnotes.in/app/backend/api_v2/ads_setting.php"
                );
                if (res.status === 200) {
                    const {
                        banner_ads
                    } = res.data;
                    if (banner_ads === "1") {
                        setShouldShowBanner(true);
                    } else {
                        setShouldShowBanner(false);
                    }
                }
            } catch (err) {
                console.error("Error fetching banner ad setting:", err);
                setShouldShowBanner(false);
            }
        };

        fetchBannerSetting();
    }, []);

    if (!shouldShowBanner) return null;

    return (
        <div >
            <div style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              minHeight: '96px',
              marginTop: '2rem'
            }}>
              <div style={{
                height: '300px',
                width: '91.666667%',
                maxWidth: '56rem',
                padding : "20px",
                backgroundColor: '#f3f4f6', // light gray background
                border: '2px dashed #d1d5db', // gray dashed border
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#4b5563', // gray text
                fontSize: '1.125rem', // text-lg
                lineHeight: '1.75rem',
                position: 'relative',
                borderRadius: '0.5rem', // rounded-lg
                overflow: 'hidden'
              }}>
                <span style={{
                  position: 'absolute',
                  zIndex: 10,
                  fontWeight: 500
                }}>Ad</span>
                <div style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <AdsComponent dataAdSlot="2597424317" />
                </div>
              </div>
            </div>
          </div>
    );
};

export default BannerAdComponent;
